import angular from 'angular';

import '../../core/main/controller/environment';

angular.module("merchant.application.main").factory("merchant.application.main.factory.acquirer", [
    "$resource",
    "core.application.main.controller.environment",
    function($resource, Environment) {

        //NOTE: The coreMerchantId refers to the merchant id directly associated with a merchant and named as such to avoid
        //confusion/conflict with the 15 digit Acquirer Merchant Id (MID).
        var resourceAcquirers = $resource(Environment.MERCHANT_PORTAL_API_BASE_URL + "/portal/merchants/:coreMerchantId/acquirers");
        var resourceAcquirer = $resource(Environment.MERCHANT_PORTAL_API_BASE_URL + "/portal/merchants/:coreMerchantId/acquirers/:ref");

        var expose = {};

        expose.populate = function(parameters, success, error) {
            resourceAcquirers.get(parameters, success, error);
        };

        expose.create = function(parameters, success, error) {
            var urlParams = {
                coreMerchantId: parameters.coreMerchantId
            };
            new resourceAcquirers(parameters).$save(urlParams, success, error);
        };

        expose.read = function(parameters, success, error) {
            resourceAcquirer.get({
                ref: parameters.ref,
                coreMerchantId: parameters.coreMerchantId
            }, success, error);
        };

        expose.update = function(parameters, success, error) {
            resourceAcquirer.put({
                ref: parameters.ref,
                coreMerchantId: parameters.coreMerchantId
            }, parameters, success, error);
        };

        expose.delete = function(parameters, success, error) {
            resourceAcquirer.delete({
                ref: parameters.ref,
                coreMerchantId: parameters.coreMerchantId
            }, success, error);
        };
        return expose;
    }
]);
